import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import DataDrivenLogoColumn from '../../components/columns/data-driven-logo-column';

export const ServiceColumnContainer = ({ isExpanded = false, serviceId = '', serviceIdCount = 1 }) => {
  const serviceReference = useSelector(Global.selectReferenceDatagetServiceReferenceLookup);
  if (!serviceId || serviceIdCount === 0) {
    return <DataDrivenLogoColumn isEmpty />;
  }

  if (!isExpanded && serviceIdCount > 1) {
    return <DataDrivenLogoColumn isMultiple />;
  }

  const service = serviceReference[serviceId];
  if (!service) {
    return <DataDrivenLogoColumn isEmpty />;
  }

  const { labelProviderId, name } = service;
  const providerId = Number.parseInt(labelProviderId, 10);

  return <DataDrivenLogoColumn dataDrivenLogoProps={{ providerId }} message={name} />;
};

ServiceColumnContainer.propTypes = {
  isExpanded: PropTypes.bool,
  serviceId: PropTypes.string,
  serviceIdCount: PropTypes.number,
};
